import { lazy } from "react";
import DashboardLayout from "../layout/Dashboard";
import ProtectedRoutes from "./ProtectedRoutes";

const Dashboard = lazy(() =>
  import("../Component/pages/otherPages/dashboard/Dashboard")
);
const Services = lazy(() =>
  import("../Component/pages/otherPages/services/Services")
);
const ServicesDetail = lazy(() =>
  import("../Component/pages/otherPages/services/ServiceDetail")
);

const BookingList = lazy(() =>
  import("../Component/pages/otherPages/bookings/Booking")
);
const BookingDetail = lazy(() =>
  import("../Component/pages/otherPages/bookings/BookingDetail")
);
const Reviews = lazy(() =>
  import("../Component/pages/otherPages/reviews/Reviews")
);
const AccountSetting = lazy(() =>
  import("../Component/pages/settingPages/AccountPage")
);
const UpdatePass = lazy(() =>
  import("../Component/pages/settingPages/UpdatePass")
);
const Calendar = lazy(() =>
  import("../Component/pages/otherPages/calendar/Calendar")
);
const CalendarMonth = lazy(() =>
  import("../Component/pages/otherPages/calendar/CalendarMonth")
);
const Categories = lazy(() =>
  import("../Component/pages/settingPages/Categories")
);
const SelectServices = lazy(() =>
  import("../Component/pages/settingPages/SelectServices")
);
const UploadDoc = lazy(() =>
  import("../Component/pages/settingPages/UploadDoc")
);
const WorkingHr = lazy(() =>
  import("../Component/pages/settingPages/WorkingHr")
);
const BusinessSetup = lazy(() =>
  import("../Component/pages/settingPages/businessSetup/BusinessSetup")
);
const ServiceAr = lazy(() =>
  import("../Component/pages/settingPages/ServiceAr")
);
const ServiceArea = lazy(() =>
  import("../Component/pages/settingPages/ServiceArea")
);
const UpdateCompDoc = lazy(() =>
  import("../Component/pages/settingPages/UpdateCompDoc")
);

const UpdateWorkingHr = lazy(() =>
  import("../Component/pages/settingPages/UpdateWorkingHr")
);

const SettingAddServices = lazy(() =>
  import("../Component/pages/otherPages/services/SettingAddServices")
);
const SettingAddSubCategories = lazy(() =>
  import("../Component/pages/otherPages/services/SettingAddSubCategories")
);
const Areas = lazy(() =>
  import("../Component/pages/otherPages/areas/SettingAreas")
);
const MyAreas = lazy(() =>
  import("../Component/pages/otherPages/areas/MyAreas")
);
const Chat = lazy(() => import("../Component/pages/otherPages/chat/Chat"));
const Payments = lazy(() =>
  import("../Component/pages/otherPages/payments/Payments")
);
const DashboardRoutes = {
  path: "/",
  Component: ProtectedRoutes,
  children: [
    // {
    //   path: "working-hr-notice-period",
    //   element: <WorkingHr />,
    // },
    {
      path: "business-setup/service-area",
      // element: <ServiceAr />,
      element: <ServiceArea />,
    },
    {
      path: "business-setup/working-hr-notice-period",
      element: <WorkingHr />,
    },
    {
      path: "business-setup/categories",
      element: <Categories />,
    },
    {
      path: "business-setup/categories/select-service/:id",
      element: <SelectServices />,
    },

    {
      path: "business-setup/upload-company-details",
      element: <UploadDoc />,
    },
    {
      path: "business-setup",
      element: <BusinessSetup />,
    },
    {
      path: "/",
      element: <DashboardLayout />,
      children: [
        {
          path: "dashboard",
          element: <Dashboard />,
        },
        {
          path: "my-services",
          element: <Services />,
        },
        {
          path: "my-services/service-detail/:id",
          element: <ServicesDetail />,
        },
        {
          path: "booking-list",
          element: <BookingList />,
        },
        {
          path: "booking-list/booking-detail/:id",
          element: <BookingDetail />,
        },
        {
          path: "reviews",
          element: <Reviews />,
        },
        {
          path: "account-setting",
          element: <AccountSetting />,
        },
        {
          path: "my-areas",
          // element: <Areas />,
          element: <MyAreas />,
        },
        {
          path: "update-password",
          element: <UpdatePass />,
        },
        {
          path: "booking-calendar",
          element: <Calendar />,
          // element: <CalendarMonth />,
        },
        {
          path: "update-company-documents",
          element: <UpdateCompDoc />,
        },
        {
          path: "update-working-hours-notice-period",
          element: <UpdateWorkingHr />,
        },
        {
          path: "add-services",
          element: <SettingAddServices />,
        },
        {
          path: "add-services/add-sub-categories/:id",
          element: <SettingAddSubCategories />,
        },
        {
          path: "chat",
          element: <Chat />,
        },
        {
          path: "payments",
          element: <Payments />,
        },
      ],
    },
  ],
};

export default DashboardRoutes;
